import { HttpResponse, http, type HttpHandler, type PathParams } from 'msw';
import { BFF_ENDPOINTS } from '../../api/endpoints/BffEndpoints';

import { createMockBillingPaymentResponse, createMockReceiptsListResponse } from '../factories/billing';
import { createMockReceiptResponse } from '../factories/receipt';

import { toMSWPattern } from '../utils/generic';
import type { HTTP_METHODS } from './constants/generic';
import { HTTP_METHODS_VALUES } from './constants/generic';

interface HandlerMapping {
  pattern: string;
  key: string;
  method?: HTTP_METHODS;
}

export interface HandlerWithMapping {
  handler: HttpHandler;
  mapping: HandlerMapping;
}

export const ENDPOINTS_KEYS = {
  BILLING_INFO: 'BILLING_INFO',
  RECEIPTS: 'RECEIPTS',
  RECEIPT: 'RECEIPT',
};

const DEFAULT_PAGE_SIZE = 6;

export function createBillingHandlers(baseUrl: string): HandlerWithMapping[] {
  const handlers: HandlerWithMapping[] = [
    {
      handler: http.get(`${baseUrl}/${toMSWPattern(BFF_ENDPOINTS.BILLING_INFO)}`, () => {
        const billingInfo = createMockBillingPaymentResponse();
        return HttpResponse.json(billingInfo);
      }),
      mapping: {
        pattern: 'billing',
        key: ENDPOINTS_KEYS.BILLING_INFO,
        method: HTTP_METHODS_VALUES.GET as HTTP_METHODS,
      },
    },
    {
      handler: http.get(`${baseUrl}/${toMSWPattern(BFF_ENDPOINTS.RECEIPTS)}`, ({ request }) => {
        const url = new URL(request.url);
        const page = Number(url.searchParams.get('page') ?? 0);
        const size = Number(url.searchParams.get('size') ?? DEFAULT_PAGE_SIZE);
        return HttpResponse.json(createMockReceiptsListResponse({ page, size }));
      }),
      mapping: {
        pattern: 'billing/receipts',
        key: ENDPOINTS_KEYS.RECEIPTS,
        method: HTTP_METHODS_VALUES.GET as HTTP_METHODS,
      },
    },
    {
      handler: http.get(
        `${baseUrl}/${toMSWPattern(BFF_ENDPOINTS.RECEIPT)}`,
        ({ params }: { params: PathParams }) => {
          console.log('[MSW] Get receipt request:', { receiptId: params.receiptId });
          return HttpResponse.json(createMockReceiptResponse());
        },
      ),
      mapping: {
        pattern: 'receipts/:receiptId',
        key: ENDPOINTS_KEYS.RECEIPT,
        method: HTTP_METHODS_VALUES.GET as HTTP_METHODS,
      },
    },
  ];
  return handlers;
}
